import { useEffect } from 'react'
import type { FishingWorldActiveEvent } from '@/lib/fishing-world-scheduler'

function eventHash(value: string) {
  let hash = 2_166_136_261
  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index)
    hash = Math.imul(hash, 16_777_619)
  }
  return hash >>> 0
}

/** Deterministic visual variation; scheduling randomness remains upstream. */
export function eventNumber(event: FishingWorldActiveEvent, salt: number) {
  return ((eventHash(`${event.id}:${salt}`) % 10_000) + 0.5) / 10_000
}

export function eventRange(event: FishingWorldActiveEvent, salt: number, minimum: number, maximum: number) {
  return minimum + eventNumber(event, salt) * (maximum - minimum)
}

export function useAmbientEventCompletion(
  event: FishingWorldActiveEvent | undefined,
  onComplete: ((eventId: string) => void) | undefined,
) {
  useEffect(() => {
    if (!event || !onComplete) return
    const timeout = window.setTimeout(() => onComplete(event.id), Math.max(0, event.expiresAtMs - Date.now()))
    return () => window.clearTimeout(timeout)
  }, [event?.id, event?.expiresAtMs, onComplete])
}
